import { Moment } from 'moment'
import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'

export default class JobEscalationDetail extends CosmosJobsDbRecordBase {
  public escalationReason: string
  public escalationDescription: string
  public deEscalationDescription: string
  public deEscalatedAt: Moment | null
}
